import gql from "graphql-tag";

export const RESET_WORKSPACE_LAYOUT = gql`
  mutation {
    resetWorkspaceLayouts
  }
`;
